import { memo, useEffect, useState } from "react";
import { Grid, Box, Typography, List, ListItem } from "@mui/material";
import { makeStyles } from "@mui/styles";

import ServicesComponent from "../components/ServicesComponent.jsx";
import { ThirdBackgroundButton } from "#components";
import { useNavigate } from "../router.js";


const useStyles = makeStyles((theme) => ({
	title: {
		color: theme.palette.primary.main,
		fontWeight: "bold",
		fontSize: "2.5rem"
	},
	summary: {
		fontWeight: "bold",
		fontSize: "x-large"
	},
	total: {
		fontWeight: "bold",
		fontSize: "large"
	},
	grey: {
		color: theme.palette.grey.silver,
		fontSize: "small",
		marginLeft: "0.2rem"
	},
	redStar: {
		color: theme.palette.red.main,
	}
}));

const ServicesPlan = () => {
	const [totalOneOff, setTotalOneOff] = useState(500);
	const [tddReportsSelected, setTddReportsSelected] = useState(false);
	const [nis2ReportsSelected, setNis2ReportsSelected] = useState(false);
	const [nonmaintainabilityReportsSelected, setNonmaintainabilityReportsSelected] = useState(false);
	const [tddReports, setTddReports] = useState(0);
	const [nis2Reports, setNis2Reports] = useState(0);
	const [nonmaintainabilityReports, setNonmaintainabilityReports] = useState(0);
	const classes = useStyles();
	const navigate = useNavigate();

	useEffect(() => {
		const validReports = (Number.isNaN(tddReports) ? 0 : tddReports) + (Number.isNaN(nis2Reports) ? 0 : nis2Reports) + (Number.isNaN(nonmaintainabilityReports) ? 0 : nonmaintainabilityReports);
		setTotalOneOff(500 * validReports);
	}, [tddReports, nis2Reports, nonmaintainabilityReports]);

	return (
		<Grid sx={{ flex: 1, display: "flex", flexDirection: "column", mb: "1rem", minHeight: "calc(100vh - 90px)" }}>
			<Grid container justifyContent="center">
				<Grid item mt={6} sx={{ mb: { xs: 3, sm: 3, md: 3, lg: 3, xl: 0 }, textAlign: "center" }}>
					<Typography alignContent={"center"} className={classes.title}>{"Configure your services"}</Typography>
				</Grid>
			</Grid>
			<Grid container flexGrow={1} display="flex" direction="row" justifyContent="center" alignItems="center" gap="5rem" pr="1rem" pl="1rem">
				<Grid item sx={{ width: "400px" }}>
					<ServicesComponent
						valueOneOff={totalOneOff}
						setTotalOneOff={setTotalOneOff}
						tddReportsSelected={tddReportsSelected}
						setTddReportsSelected={setTddReportsSelected}
						nis2ReportsSelected={nis2ReportsSelected}
						setNis2ReportsSelected={setNis2ReportsSelected}
						tddReports={tddReports}
						setTddReports={setTddReports}
						nis2Reports={nis2Reports}
						setNis2Reports={setNis2Reports}
						nonmaintainabilityReportsSelected={nonmaintainabilityReportsSelected}
						setNonmaintainabilityReportsSelected={setNonmaintainabilityReportsSelected}
						nonmaintainabilityReports={nonmaintainabilityReports}
						setNonmaintainabilityReports={setNonmaintainabilityReports}
					/>
				</Grid>
				<Grid item container direction="column" sx={{ width: "400px" }}>
					<Grid item direction="row" sx={{ backgroundColor: "#e0eaf2", pt: "0.5rem", pb: "0.5rem", pl: "1rem", pr: "1rem" }}>
						<Typography className={classes.summary}>{"Summary"}</Typography>
						<Box display="flex" alignItems="baseline" pb="1rem">
							<Typography className={classes.total}>{`Total: €${totalOneOff}`}</Typography>
							<Typography className={classes.grey} variant="body2">one-off</Typography>
							<Typography className={classes.redStar} sx={{ marginLeft: "0.2rem" }}>*</Typography>
						</Box>
						<Typography>{"Your plan includes:"}</Typography>
						<List sx={{ listStyleType: "disc", pl: "1rem", pt: "0rem", pb: "0rem" }}>
							{tddReportsSelected && (
								<ListItem disableGutters sx={{ display: "list-item", p: 0 }}>
									<Typography>{`${tddReports} Technical Due Diligence Report${tddReports > 1 ? "s" : ""}`}</Typography>
								</ListItem>
							)}
							{nis2ReportsSelected && (
								<ListItem disableGutters sx={{ display: "list-item", p: 0 }}>
									<Typography>{`${nis2Reports} Nis2 Report${nis2Reports > 1 ? "s" : ""}`}</Typography>
								</ListItem>
							)}
							{nonmaintainabilityReportsSelected && (
								<ListItem disableGutters sx={{ display: "list-item", p: 0 }}>
									<Typography>{`${nonmaintainabilityReports} Non-Maintainability Report${nonmaintainabilityReports > 1 ? "s" : ""}`}</Typography>
								</ListItem>
							)}
						</List>
						<Box display="flex" alignItems="center">
							<Typography className={classes.redStar}>*</Typography>
							<Typography className={classes.grey}>+ VAT if applicable</Typography>
						</Box>
					</Grid>
					<Grid item pl="1rem" pt="1rem" pb="1rem">
						<ThirdBackgroundButton
							id="configure-solo-plan-button"
							disabled={!tddReportsSelected && !nis2ReportsSelected && !nonmaintainabilityReportsSelected}
							width="200px"
							title="Proceed to Checkout"
							onClick={() => navigate(`../checkout?tddReports=${tddReportsSelected ? tddReports : 0}&nis2Reports=${nis2ReportsSelected ? nis2Reports : 0}&nonmaintainabilityReports=${nonmaintainabilityReportsSelected ? nonmaintainabilityReports : 0}`)}
							// onClick={() => window.location.assign(`https://cyclopt.com/lets-start/?nis2Reports=${nis2ReportsSelected ? nis2Reports : 0}&tddReports=${tddReportsSelected ? tddReports : 0}&nonmaintainabilityReports=${nonmaintainabilityReportsSelected ? nonmaintainabilityReports : 0}`)}
						/>
					</Grid>
				</Grid>
			</Grid>
		</Grid>

	);
};

export default memo(ServicesPlan);
